import "./Pagination.css";

export function Pagination({ current, setCurrent }) {
  return (
    <div className="pagination-list">
      <div
        onClick={() => setCurrent(1)}
        className={`pagination-item ${current === 1 ? "active" : ""}`}
      >
        1
      </div>
      <div onClick={() => setCurrent(2)} className="pagination-item"
      className={`pagination-item ${current === 2 ? "active" : ""}`}
      >
        2
      </div>
      <div onClick={() => setCurrent(3)} className="pagination-item"
      className={`pagination-item ${current === 3 ? "active" : ""}`}
      >
        3
      </div>
      <div onClick={() => setCurrent(4)} className="pagination-item"
      className={`pagination-item ${current === 4 ? "active" : ""}`}
      >
        4
      </div>
      <div onClick={() => setCurrent(5)} className="pagination-item"
      className={`pagination-item ${current === 5 ? "active" : ""}`}
      >
        5
      </div>
    </div>
  );
}
